(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/account-selector/assets/javascripts/collections/account-selector-syndicates.js') >= 0) return;  svs.modules.push('/components/syndicate/account-selector/assets/javascripts/collections/account-selector-syndicates.js');

(function(Backbone, svs) {
  'use strict';

  svs.syndicate.account_selector.collections.Syndicates = Backbone.Collection.extend({
    preserve: true,

    url: svs.core.jupiter.url() + '/social/1/syndicates',

    parse: function(data) {
      var syndicates = data.customerSyndicates || data;
      svs.syndicate.account_selector.logger.debug('Has parsed ' + syndicates.length + ' syndicates');
      if (!data.error && syndicates) {
        svs.syndicate.account_selector.data.syndicates = syndicates;
        return syndicates;
      }

      var dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        type: svs.ui.dialog.type.ERROR,
        title: 'Tekniskt fel',
        message: [
          {
            type: svs.ui.dialog.message.TEXT,
            text: 'Det gick inte att hämta spelkonton, vänligen försök igen.'
          }
        ],
        actions: [{ title: 'Ok' }]
      });
      svs.ui.dialog.api.add(dialog);

      svs.syndicate.account_selector.logger.error('Error parsing syndicates. Syndicates: ' + syndicates + ', Error: ' + data.error);
    }
  });
})(Backbone, svs);


 })(window);